import { RouteItem } from '@eastcoal/router/types/route'

import { RANKING_AUCTION_SALE_LIST_PAGE_PATH } from './constants/path'

export const rankingAuctionSaleListRoute: RouteItem = {
  title: '竞拍（排名）',
  path: RANKING_AUCTION_SALE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
